<div [ngClass]="theme.getThemeClass()" class="table-container">
  <nav class="device-filter">
    <div class="sort-by-group">
      <label class="sort-by-group-label">{{ "clientDevices" | translate }}</label>
      <select
        [(ngModel)]="selectedClient"
        class="form-control sort-by-group-select"
        name="thingGroup"
        (change)="sortByClients()"
      >
        @for (option of clientSelectOptions; track option.value) {
          <option [ngValue]="option.value">
            {{ option.label | translate }}
          </option>
        }
      </select>
    </div>
    <div
      class="sort-by-group"
      [ngClass]="{
        disabled: selectedClient.trim() === ''
      }"
    >
      <label class="sort-by-group-label">{{ "deviceGroup" | translate }}</label>
      <select
        [(ngModel)]="filterThingSubGroup"
        class="form-control sort-by-group-select"
        name="thingGroup"
        (change)="sortByClientSubGroups()"
      >
        @for (option of clientSubGroupOptions; track option.value) {
          <option [ngValue]="option.value">
            {{ option.label | translate }}
          </option>
        }
      </select>
    </div>
  </nav>

  <section [ngClass]="theme.getThemeClass()" class="devices-location-section">
    <app-devices-map [devices]="filteredDevicesWithGps"></app-devices-map>
  </section>
</div>

@if (iscloseClientSelectModalOpen) {
<div class="modal-overlay" (click)="closeClientSelectModal()">
  <div class="modal-content" [ngClass]="theme.getThemeClass()" (click)="$event.stopPropagation()">
    <button class="close-button" (click)="closeClientSelectModal()">
      &times;
    </button>

    <h3>{{ "selectClientCreateSubGroup" | translate }}</h3>

    <select id="clientSelect" [(ngModel)]="selectedClientId">
      <option [ngValue]="null" disabled selected>
        {{ "selectClient" | translate }}
      </option>
      @for (client of thingClient; track client.client_id) {
        <option [ngValue]="client.client_id">
          {{ client.legal_name }}
        </option>
      }
    </select>

    <div class="btns">
      <button class="btn" [disabled]="!selectedClientId" (click)="confirmSubgroupClient()">
        {{ "usereditFormLabelConfirm" | translate }}
      </button>
      &nbsp;
      <button class="btn" (click)="closeClientSelectModal()">
        {{ "cancel" | translate }}
      </button>
    </div>
  </div>
</div>
}
